export enum DateTruncEnum {
	Microseconds = 'microseconds',
	Milliseconds = 'milliseconds',
	Second = 'second',
	Minute = 'minute',
	Hour = 'hour',
	Day = 'day',
	Week = 'week',
	Month = 'month',
	Quarter = 'quarter',
	Year = 'year',
	Decade = 'decade',
	Century = 'century',
	Millennium = 'millennium',
}
